import React from "react";
import { ReportField } from "./ReportField";
import { Box } from "@mui/material";

interface PropertyOverviewContainerProps {
  userId: string;
  propertyId: string;
}

export const PropertyOverviewContainer: React.FC<
  PropertyOverviewContainerProps
> = ({ userId, propertyId }) => {
  return (
    <Box sx={{ pl: 6 }}>
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Building Name"
        fieldKey="propertyOverview.buildingName"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Age of Building"
        fieldKey="propertyOverview.ageOfBuilding"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Construction Type"
        fieldKey="propertyOverview.constructionType"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Number of Units"
        fieldKey="propertyOverview.numberOfUnits"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Number of Floors"
        fieldKey="propertyOverview.numberOfFloors"
      />
    </Box>
  );
};
